import { render, staticRenderFns } from "./bohuizfbsh.vue?vue&type=template&id=7f55c12b&scoped=true&"
import script from "./bohuizfbsh.vue?vue&type=script&lang=js&"
export * from "./bohuizfbsh.vue?vue&type=script&lang=js&"
import style0 from "./bohuizfbsh.vue?vue&type=style&index=0&id=7f55c12b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f55c12b",
  null
  
)

export default component.exports